import {useQueryClient} from '@tanstack/react-query';
import {memo, useEffect} from 'react';
import {Outlet} from 'react-router';

import {PREFETCH_QUERIES} from '#queries/config.js';
import {prefetchQueries} from '#queries/utils.js';

import {Shell} from './components/shell/index.js';

export const AuthenticatedLayout = memo(function AuthenticatedLayout() {
  const queryClient = useQueryClient();

  useEffect(() => {
    prefetchQueries(queryClient, PREFETCH_QUERIES);
  }, [queryClient]);

  return (
    <Shell>
      <Outlet />
    </Shell>
  );
});
